'use client';

import { fakeInputBorderColor } from "../TextField.css.js";
function getFakeInputBorderClassName({
  disabled,
  error
}) {
  if (disabled) return fakeInputBorderColor.disabled;
  if (error) return fakeInputBorderColor.invalid;
  return fakeInputBorderColor.default;
}
export {
  getFakeInputBorderClassName
};
